import React from 'react';
import PropTypes from 'prop-types';
import {
  EmptyStateBox,
  EmptyStateHeaderWrapper,
  EmptyStateHeader,
  EmptyStateBody,
  EmptyStateButton,
  EmptyStateImage,
} from './EmptyStateStyles';

const EmptyStateView = ({
  title, subtitle, buttonText, onButtonClick, image,
}) => (
  <EmptyStateBox>
    <EmptyStateHeaderWrapper>
      <EmptyStateImage src={image} alt="illustration" />
      <EmptyStateHeader>{title}</EmptyStateHeader>
      <EmptyStateBody>{subtitle}</EmptyStateBody>
    </EmptyStateHeaderWrapper>
    <EmptyStateButton onClick={onButtonClick}>{buttonText}</EmptyStateButton>
  </EmptyStateBox>
);

EmptyStateView.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  onButtonClick: PropTypes.func.isRequired,
};

export default EmptyStateView;
